<template>
  <div class="home-view internal">
    <section class="list">
      <transition name="fade" mode="out-in">
        <div class="container" v-if="loaded">
          <h1 class="title-default">Comunicados<span>Aqui ficam as mensagens importantes que a Fibra Experts manda pra você!</span></h1>

          <ul v-if="!!items.length">
            <li v-for="item in items" :key="item.id">
              <div class="right">
                <div class="alert-header">
                  <h2 v-if="!!item.comunicado.titulo">{{ item.comunicado.titulo }}</h2>

                  <span class="date">{{ new Date(item.comunicado.data || item.dataEnvio) | moment('DD/MM/YYYY') }}</span>
                </div>

                <!-- <p v-if="!!item.comunicado.data"><small>{{ item.comunicado.data }}</small></p> -->

                <picture v-if="item.comunicado.imagemDesktop || item.comunicado.imagemMobile">
                  <source
                      v-if="!!item.comunicado.imagemMobile"
                      media="(max-width: 800px)"
                      :srcset="item.comunicado.imagemMobile"
                  >

                  <source
                      v-if="!!item.comunicado.imagemDesktop"
                      media="(min-width: 800px)"
                      :srcset="item.comunicado.imagemDesktop"
                  >

                  <img :src="item.comunicado.imagemDesktop" :alt="item.comunicado.titulo">
                </picture>

                <div v-if="!!item.comunicado.videoYoutubeId">
                  <iframe :src="`https://youtube.com/embed/${item.comunicado.videoYoutubeId}?rel=0`"></iframe>
                </div>

                <div v-if="!!item.comunicado.arquivo">
                  <a
                      :href="item.comunicado.arquivo"
                      class="comunicado-file"
                      target="_blank"
                      title="Arquivo"
                  >
                    Baixar documento
                  </a>
                </div>

                <p v-if="!!item.comunicado.mensagem" v-html="breakLine(item.comunicado.mensagem)" />
              </div>
            </li> <!-- /li -->
          </ul> <!-- /ul -->

          <ul v-else>
            <li class="empty">
              <h2 class="aligncenter">Nenhum item.</h2>
            </li>
          </ul>
        </div> <!-- /.container -->
      </transition>
    </section> <!-- /.list -->
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'

export default {
  name: 'comunicados',

  data () {
    const data = {
      items: [],
      loaded: false
    }

    return data
  },

  beforeMount () {
    this.loadList()
  },

  mounted () {
  },

  methods: {
    async loadList () {
      try {
        const { contratoAtual, codigoCliente } = this.$store.state

        let xhr = await PagesService.getComunicados(codigoCliente, contratoAtual.empreendimentoIdWeb)

        const arrIds = []
        const items = []

        xhr.map(item => {
          if (!arrIds.includes(item.comunicadoId)) {
            items.push(item)
            arrIds.push(item.comunicadoId)
          }

          return item
        })

        this.items = items.map(({ comunicado, ...item }) => ({
          ...item,
          comunicado: {
            ...comunicado,
            ...(comunicado || {}),
            ...(comunicado.imagemDesktop ? {
              imagemDesktop: `${Vue.prototype.urlFiles}/comunicados/${comunicado.imagemDesktop}`
            } : {}),
            ...(comunicado.imagemMobile ? {
              imagemMobile: `${Vue.prototype.urlFiles}/comunicados/${comunicado.imagemMobile}`
            } : {}),
            ...(comunicado.arquivo ? {
              arquivo: `${Vue.prototype.urlFiles}/comunicados/${comunicado.arquivo}`
            } : {})
          }
        }))

        this.loaded = true
        this.$store.commit('setBadge', xhr.total || 0)
      } catch (e) {
        console.error('Falha ao recuperar documentos', e)
      }
    }, // loadList()

    breakLine (str = '') {
      return str.replace(/\n/gi, '<br />')
    }
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .right
    .alert-header
      margin-bottom: 15px

      h2
        font-size: 24px
        font-weight: bold

      span.date
        font-size: 12px
        color: #444

    picture img
      width: 100%
      max-width: 600px
      display: block
      margin-bottom: 15px

    iframe
      max-width: 100%
      width: 700px
      height: 395px
      display: block
      margin-bottom: 15px

    .comunicado-file
      text-decoration: underline
      color: map-get($colors, primary)
      margin-bottom: 15px
      display: block
      font-weight: 600

    @media (max-width: 767px)
      iframe
        height: 200px
</style>
